"use client";

import { FC } from "react";
import { Theme } from "apps/website/maps/Theme.map";

import Section from "../../layout/Section/Section";
import { getSectionSize } from "../../layout/Section/Section.utils";
import Container from "../../layout/Container/Container";
import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";
import Image, { IImageProps } from "../../base/Image/Image";
import Button, { IButton } from "../../base/Button/Button";
import HorizontalIconTextList, {
  IHorizontalIconTextList,
} from "../../feature/HorizontalIconTextList/HorizontalIconTextList";
import TextTitle from "../../base/Text/TextTitle/TextTitle";
import TextSubtitle from "../../base/Text/TextSubtitle/TextSubtitle";
import Spacer from "../../layout/Spacer/Spacer";

export interface ISectionHorizontalItemTextListProps {
  title: string;
  subtitle?: string;
  ctas?: IButton[];
  image: IImageProps;
  list: IHorizontalIconTextList;
  theme?: Theme;
}

const SectionHorizontalItemTextList: FC<ISectionHorizontalItemTextListProps> = ({ title, subtitle, image, ctas, list, theme = "default" }) => (
  <Section component={SectionHorizontalItemTextList.name} theme={theme} size={getSectionSize(theme)}>
    <Container>
      <Grid>
        <Column align="center">
          <TextTitle align="center" data-testid="SectionHorizontalItemTextListTitle">{ title }</TextTitle>
          { subtitle ? (
            <>
              <Spacer size="lg" />
              <TextSubtitle align="center" data-testid="SectionHorizontalIconTextListSubtitle">{ subtitle }</TextSubtitle>
            </>
          ) : null }
          <Spacer size="lg" />
        </Column>
        <Column>
          <Grid gap="xl">
            <Column spans={{ xl: 6 }} offset={{ xl: 4 }}>
              <Image
                image={image}
                alt={title}
                data-testid="SectionHorizontalItemTextListImage"
              />
            </Column>
            <Column
              spans={ { xl: 8 } }
              offset={ { xl: 3 } }
              justify="center"
              align={"center"}
            >
              <HorizontalIconTextList {...list} />
            </Column>
          </Grid>
          <Spacer size="xl" />
        </Column>
        <>
          { ctas?.length ? (
            <Column align="center" justify="center">
              { ctas.map((cta, index) => (
                <Button key={index} {...cta} />
              )) }
            </Column>
          ) : null }
        </>
      </Grid>
    </Container>
  </Section>
);

export default SectionHorizontalItemTextList;
